import Cookies from 'js-cookie';
import swal from 'sweetalert';

document.addEventListener("DOMContentLoaded", function() {
	//find any branch picker element on this page
	let branch_pickers = document.querySelectorAll('select[name="nearest_branch"], select[name="nearest_branch_all"]');

	//if we have branch pickers
	if(branch_pickers && branch_pickers.length > 0) {

		//loop over the branch pickers
		for(let i = 0; i < branch_pickers.length; i++) {

			//attack our listener event
			branch_pickers[i].onchange = branch_picker_listener;
		}
	}

	function branch_picker_listener(event) {

		//attempt to get our email/name pair of branches from the ajax object
		let branches = ((typeof window.branch_emails != 'undefined') ? window.branch_emails : false);
		let branches_default_email = 'web-enquiry@bushtyres.co.uk';

		//if we have a branch pair
		if(branches) {

            //loop through our branches and convert the keys from html entities to plain text
            for(let branch in branches) {

                //create a new textarea element
                var txt = document.createElement("textarea");

                //set the branch as the innerHTML
                txt.innerHTML = branch;

                //get the HTML save value
                let decoded_key = txt.value;

                //remove the textarea element
                txt.remove();

                //if the key is different to the decoded key
                if(branch != decoded_key) {

                    //add the decoded key to the branches object
                    branches[decoded_key] = branches[branch];

                    //delete the old key
                    delete branches[branch];
                }
            }

			//attempt to get the closest branch email field
			let form = (event.target).closest('form');
			let branch_email_field = form.querySelector('input[name="branch_email"]');
			let branch_email_cc_field = form.querySelector('input[name="branch_email_cc"]');

            //attempt to get our fulfillment type
            let fulfillment_type = Cookies.get('bt_fulfillment_type');

			//find the branch that's been chosen
			let chosen_branch = event.target.value;

			//if we have a selected branch and a branch email field to save to
			if(chosen_branch && branch_email_field) {

				//if the chosen branch exists in the list of branches
				if(chosen_branch in branches) {

                    //if the fulfillment type is mobile fitting and we have a secondary email
                    if(fulfillment_type && fulfillment_type.includes('mobile_fitting') && branches[chosen_branch].secondary) {

                        //set the branch email field to the secondary email
                        branch_email_field.value = branches[chosen_branch].secondary;

                    } else { //otherwise...

                        //set the branch email field to the primary
                        branch_email_field.value = branches[chosen_branch].primary;
                    }

                    //if we have a CC field
                    if(branch_email_cc_field && branches[chosen_branch].cc) {

                        //add our CC fields to the form
                        branch_email_cc_field.value = branches[chosen_branch].cc;
                    }

				} else { //...otherwise

					//set this to the default branch field
					branch_email_field.value = branches_default_email;
				}
			}
		} else {

            //create an error notification
            swal({
                title: 'Branch Information Unavailable',
                text: 'Unable to fetch branch information, please refresh the page and try again.',
                timer: 6000
            });
        }
	}
});